import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "CalendarStrong",
  "use": "CalendarStrong-usage",
  "viewBox": "0 0 62 57",
  "content": "<symbol viewBox=\"0 0 62 57\" xmlns=\"http://www.w3.org/2000/svg\" id=\"CalendarStrong\"><title>CALENDARIO-BOLD</title><path d=\"M55.835 15.814v-4.83h-8.01v2.541H41.3v-2.542H20.09v2.542h-6.526v-2.542H6.168v5.44h49.666v-.61zm0 7.118H6.169v27.915h49.666V22.932zm-8.01-18.101H62V57H0V14.492 4.83h13.563V1.932 0h6.526V4.831h21.21V1.932 0h6.527V4.831zM11 27h10v7H11v-7zm15 0h10v7H26v-7zm15 0h10v7H41v-7zM11 39h10v7H11v-7zm15 0h10v7H26v-7zm15 0h10v7H41v-7z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol